<p-toast></p-toast>
<ng-container>
    <div class="ui-g-12">
        <h2 class="heading3 nameHeading">Welcome, {{doctorICard.first_name}}</h2>
        <div class="ui-g">
            <div class="ui-g-12 ui-md-6">
                <div class="card two-d-card-diet">
                    <div class="card-body">
                        <h5 class="card-title dashdieth5 egd-color font-weight-bolder ml-1 heading5 text-center">
                            New Appointments
                        </h5>
                        <div class="card-text">
                            <div class="listStyle">
                                <ul *ngIf="listOfAppointmentToShow.length" class="ulStyle ulNewStyle">
                                    <li *ngFor="let appointment of listOfAppointmentToShow"
                                        class="liStyle dietbtndiv borderClass">
                                        <div class="dietlist">
                                            <img src={{appointment.patientImg}} class="imgdietStyle">
                                        </div>
                                        <div class="dashddietcarddiv">
                                            <div class="dietbtndiv">
                                                <span class="dietdivtextl">{{appointment.Name}}
                                                </span>
                                                <span class="dietdivtextr">{{appointment.dateOfConsultation |
                                                    date:'mediumDate'}}
                                                </span>
                                            </div>
                                            <div class="dietbtndiv">
                                                <button pButton type="button" label="Check"
                                                [routerLink]="'../appointments/patient-view/'+ appointment.patientGuid + '/' + appointment.consultationId"
                                                    class="dietbtn dashbutton cardmargin"></button>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                                <p class="exeption" *ngIf="listOfAppointmentToShow.length == 0">No Appointments Found</p>
                            </div>
                            <div class="dietbtndiv text-center">
                                <button pButton type="button" [routerLink] = "['../appointments']"
                                label="View All"
                                    class="dashbutton cardmargin"></button>
                            </div>
                        </div>
                        <p class="exeption" *ngIf="serverError">{{serverError.error}}</p>
                    </div>
                </div>
            </div>
            <div class="ui-g-12 ui-md-6" *ngIf="role_id!=7">
                <div class="card two-d-card-diet">
                    <div class="card-body">
                        <h5 class="card-title dashdieth5 egd-color font-weight-bolder ml-1 heading5 text-center">
                            Messages
                        </h5>
                        <div class="card-text">
                            <div class="listStyle">
                                <ul *ngIf="listOfMessageToShow.length" class="ulStyle ulNewStyle ">
                                    <li class="liStyle dietbtndiv borderClass" *ngFor="let msg of listOfMessageToShow">
                                        <div class="dietlist">
                                            <img src={{msg.patientImg}} class="imgdietStyle">
                                        </div>
                                        <div class="dashddietcarddiv">
                                            <div class="dietbtndiv">
                                                <span class="dietdivtext">{{msg.Name}}
                                                </span>
                                                <span class="dietdivtextr">{{msg.date | date:'mediumDate'}}
                                                </span>
                                            </div>
                                            <div class="dietbtndiv">
                                                <!-- <a href="" target="_blank" rel="noopener noreferrer"><button pButton
                                                        type="button" label="Join Now"
                                                        class="dietbtn dashbutton cardmargin"></button></a>
                                                        mailview/:user_guid/:message_id/:sent-->
                                                <button pButton type="button"
                                                [routerLink] = "'../mailview/' + this.slug + '/' + msg.userID + '/' + msg.messageId + '/false'"
                                                    label="View" class="dietbtn dashbutton cardmargin"></button>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                                <p class="exeption" *ngIf="listOfMessageToShow.length == 0">No Messages Found</p>
                            </div>
                            <div class="dietbtndiv text-center">
                                <button pButton type="button" [routerLink] = "['../', this.slug, 'message-center']"
                                label="View All"
                                    class="dashbutton cardmargin"></button>
                            </div>
                            <p class="exeption" *ngIf="serverError">{{serverError.error}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container>
    <div class="ui-g-12">
        <div class="ui-g">

            <div class="card two-d-card-diet">
                <div class="card-body">
                    <h5 class="card-title dashdieth5 egd-color font-weight-bolder ml-1 heading5 text-center">
                        Ongoing Appointments
                    </h5>
                    <div class="card-text  ">

                        <div class="row " *ngFor="let ongoingAppointment of listOfOnGoingAppointmentToShow">
                            <div class="ui-g-12 ui-sm-3 borderClassColor ">
                                <div class="divStyle ui-g-6 ui-sm-3">
                                    <b>
                                        <p>{{ongoingAppointment.Name}}</p>
                                    </b>
                                </div>
                                <div class="divStyle ui-g-6 ui-sm-3">
                                    <div class="dietbtndiv">
                                        <button pButton type="button" [routerLink] = "['../appointments']" label="Details"
                                            class="rescedulebtn"></button>
                                    </div>
                                </div>
                                <div  class="ui-g-12 ui-sm-3"  >
                                    <b>
                                        <p>{{ongoingAppointment.dateOfConsultation | date:'mediumDate'}}</p>
                                    </b>
                                </div>
                            </div>

                            <!-- <div class="ui-g-3 ui-sm-6">
                                <div class="dietbtndiv">
                                    <a href="" target="_blank" rel="noopener noreferrer"><button pButton type="button"
                                            label="Reschedule" class="reschedulebtn"></button></a>
                                </div>
                                <div class="dietbtndiv">
                                    <a href="" target="_blank" rel="noopener noreferrer"><button pButton type="button"
                                            label="Cancel" class="cancelbtn"></button></a>
                                </div>
                            </div> -->
                        </div>
                        <p class="exeption" *ngIf="listOfOnGoingAppointmentToShow.length == 0">No Appointments Found</p>

                    </div>
                </div>
            </div>

        </div>
    </div>
</ng-container>
